var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 81,
    viewBox: "0 0 83 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.723 43.875h-6.88v-20.25h6.88m-6.88 27h6.88v6.75h-6.88m16.272-47.25H28.451L10.32 27.911V53.09l18.13 17.786h25.664l18.13-17.786V27.91l-18.13-17.786z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOctagon);
export default __webpack_public_path__ + "static/media/warning-octagon.99c10906fc5001a09f406fc85ebaf819.svg";
export { ForwardRef as ReactComponent };